export default __webpack_public_path__ + "static/media/portrait.836494ce.jpg";